export default __webpack_public_path__ + "static/media/DASHAM-dark.3014d6c4.svg";